import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';
import PreloaderClass from './PreloaderClass';

/**
 * 二重送信制御 クラス
 */
export default class DoubleSubmitControlClass extends BaseClass {
  constructor(_target) {
    super();
    this.name = 'DoubleSubmitControlClass';

    this.SUBMITTED_FLAGE = false;

    this.target = _target;

    if ($('#submit_loader').length === 0) {
      $('#main').prepend('<div id="submit_loader" class="css_loader"></div>');
    }
    this.loader_element = $('#submit_loader');
    this.css_loader = new PreloaderClass(this.loader_element);
    this.onSubmitListener = this.onSubmit.bind(this);
  }

  onCreate() {
    super.onCreate();

    if (this.target.get(0).tagName === 'FORM') {
      this.$form = $(this.target.get(0));
    } else if (this.target.get(0).tagName === 'A') {
      this.target.on('click', this.onSubmitListener);
      return;
    } else {
      /** @type {jQuery} submitボタンがある親formタグ */
      this.$form = $(this.target.get(0).form);
    }

    this.$form.on('submit', this.onSubmitListener);
  }

  onSubmit(e) {
    // リンクの場合、「CTRL+CLICK」で別のタグを開くとき、loader出さない
    if (e.currentTarget.tagName === 'A' && event.ctrlKey) {
      return;
    }

    if (e.isDefaultPrevented()) {
      return;
    } else if (this.SUBMITTED_FLAGE) {
      e.preventDefault();
      return;
    }

    if (this.$form && this.$form.length > 0) {
      // formタグ内の入力フォームにreadonly属性を加えて入力できないようにする
      $(':input', this.$form).attr('readonly', 'readonly');
    }

    this.submitOff();
  }

  submitOn() {
    this.target.removeClass('disable');
    this.SUBMITTED_FLAGE = false;
    this.css_loader.onHide();
  }

  submitOff() {
    this.target.addClass('disable');
    this.SUBMITTED_FLAGE = true;
    this.css_loader.onShow();
  }
}
